module.exports = __webpack_public_path__ + "img/iceskating002.6268824b.jpg";